export interface OrganizationDetails {
  id: string;
  alias: string;
  title: string;
  shortTitle: string;
  websiteTitle?: string;
  phoneNumber: string;
  emailAddress: string;
  address: string;
  brandColor: {
    main: string;
    alpha: string;
    darken: string;
  };
}

export const ORGANIZATION_SETTIGS_BY_ALIAS: Record<
  string,
  OrganizationDetails | undefined
> = {
  anima: {
    id: "6507f3d5-ba4e-44f9-b0d0-33e7ab5810d1",
    alias: "anima",
    title: "Kūno priežiūros studija - ANIMA",
    shortTitle: "ANIMA",
    websiteTitle: "ANIMA - kūno priežiūra",
    phoneNumber: "+37068390851",
    emailAddress: "masazasvakuuminis@gmail.com",
    address: "Vytauto pr. 13, Kaunas",
    brandColor: {
      main: "#b84781",
      alpha: "#b8478180",
      darken: "#95406b",
    },
  },
  pavyzdys: {
    id: "22405289-acf2-4236-8597-ef68e8cdfd22",
    alias: "pavyzdys",
    title: "Pavyzdinė rezervacijos sistema",
    shortTitle: "Pavyzdys",
    phoneNumber: "+37060000000",
    emailAddress: "info@takeblock.com",
    address: "Debesų technologijų pr. 123, Kaunas",
    brandColor: {
      main: "#5e5e5e",
      alpha: "#5e5e5e80",
      darken: "#4a4a4a",
    },
  },
};
